// LoadingSplash.tsx — Centered spinner shown while the auth
// listener resolves (and on page refresh before the warm cache or
// Firebase decides). Circle, not a shimmer card: the shimmer card
// was a layout-shape preview useful for per-page data loads but
// the full-page splash needs the lighter "we're working" signal of
// a spinner.

export function LoadingSplash() {
  return (
    <div className="console-splash">
      <div
        className="console-spinner"
        role="status"
        aria-label="Loading"
      />
    </div>
  );
}
